import {
  backgroundContain,
  backgroundCover,
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  socialMediaIconStyles,
  typoParagraph,
} from 'components/Templates/styles/Red/commonObjectsStyles';

import wwwIcon from 'components/Templates/globalAssets/icons/icons_website.svg';
import facebookIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_facebook.svg';
import linkedinIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_linkedin.svg';
import twitterIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_twitter.svg';
import instagramIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_instagram.svg';
import commonStyles from 'components/Templates/styles/Red/commonStyles';

const {
  iconBackgroundColor
} = commonStyles;
/* eslint-disable */
export default
{
  speakerContainer: {
    '0': {
      ...backgroundContain,
      'background-repeat-x':'repeat',
      'text-align' : 'center',
      'margin-bottom': '0.5rem',
      'padding-right': '1rem',
      'min-width': '16rem',
      'overflow': 'hidden'
    }
  },
  speakerName: {
    '0': {
      'text-align': 'left',
      'display': 'flex',
    }
  },
  firstName: {
    '0': {
      'font-size': '1.6rem',
      'color' : '{textColor}',
      'margin-right': '0.25em'
    }
  },
  lastName: {
    '0': {
      'font-size': '1.6rem',
      'color' : '{textColor}',
      'white-space': 'nowrap',
      'overflow': 'hidden',
      'text-overflow': 'ellipsis'
    }
  },
  speakerLogoContainer: {
    '0': {
      'position': 'relative',
      'width': '100%',
      'height': '3.5rem',
      'background-color': 'transparent'
    }
  },
  speakerLogo: {
    '0': {
      ...backgroundContain,
      width: '100%',
      height: '100%',
      'background-repeat': 'no-repeat',
      'background-position': '50%'
    },
  },
  speakerAvatar: {
    '0': {
      ...backgroundCover,
      'background-position-y': 'center',
      'width': '6rem',
      'height': '6rem',
      'display' : 'block',
      'position' : 'relative',
      'border-radius': '50%',
      'margin-bottom': '0.5rem',
      'margin-right': '0.5rem',
      'float': 'left'
    }
  },
  speakerJob: {
    '0': {
      ...typoParagraph,
      'line-height': '1.15',
      'font-size': '1.6rem',
      'color': '{secondaryTextColor}',
      'text-align': 'left',
      'white-space': 'nowrap',
      'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'max-width': '65%'
    },
  },
  speakerComapny: {
    '0': {
      ...typoParagraph,
      'color': '{secondaryTextColor}',
      'line-height': '1.15',
      'text-align': 'left',
      'white-space': 'nowrap',
      'overflow': 'hidden',
      'text-overflow': 'ellipsis'
    },
  },
  speakerIcons: {
    '0': {
      'margin-top' : 'auto',
      'width' : '100%',
      'overflow' : 'hidden',
      'display': 'none'
    },
  },
  speakerFacebookIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+facebookIcon+')',
    },
  },
  speakerLinkedinIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+linkedinIcon+')',
    },
  },
  speakerTwitterIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+twitterIcon+')',
    },
  },
  speakerInstagramIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+instagramIcon+')',
    },
  },
  speakerWWWIcon: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-color': iconBackgroundColor,
      'background-image': 'url('+wwwIcon+')', //another color version of svg?
      
    },
  }
}
